import React from "react";
import {
  IoIosArrowDroprightCircle,
  IoIosArrowDropleftCircle,
} from "react-icons/io";
// import { GoPrimitiveDot } from "react-icons/go";
import slider1 from "../../../assets/images/slider/slider-1.jpg";
import slider2 from "../../../assets/images/slider/slider-2.jpg";
import slider3 from "../../../assets/images/slider/slider-3.jpg";

const Banner = () => {
  return (
    <div data-aos="fade-left" data-aos-duration="2000">
      <div
        id="carouselExampleCaptions"
        className="carousel slide relative rounded-md md:rounded-lg"
        data-bs-ride="carousel"
      >
        <div className="carousel-indicators w-[66px] md:w-[75px] lg:w-[85px] mx-auto absolute right-0 -bottom-2.5 md:-bottom-1.5 lg:bottom-0 left-0 flex justify-center p-0 mb-4">
          <button
            type="button"
            className="active"
            data-bs-target="#carouselExampleCaptions"
            data-bs-slide-to="0"
            aria-current="true"
            aria-label="Slide 1"
          ></button>
          <button
            type="button"
            data-bs-target="#carouselExampleCaptions"
            data-bs-slide-to="1"
            aria-label="Slide 2"
          ></button>
          <button
            type="button"
            data-bs-target="#carouselExampleCaptions"
            data-bs-slide-to="2"
            aria-label="Slide 3"
          ></button>
        </div>

        <div className="carousel-inner relative w-full overflow-hidden">
          <div className="carousel-item active relative float-left w-full">
            <img
              src={slider1}
              className="block w-full h-[220px] md:h-[300px] lg:h-[525px] rounded-sm"
              alt="..."
            />

            <div
              className="carousel-caption hidden md:block absolute 
            left-[11.5%] bottom-0 md:bottom-6 lg:bottom-16 opacity-75"
            >
              <h5 className="text-[11px] md:text-[14.5px] lg:text-[25px] text-black font-extrabold uppercase">
                Recycle Hut
              </h5>
              <p className="text-black font-semibold text-[9.5px] md:text-[11px] lg:text-[15.5px] w-36 md:w-full">
                The best way for buying and selling your used phones
              </p>
            </div>
          </div>

          <div className="carousel-item relative float-left w-full">
            <img
              src={slider2}
              className="block w-full h-[220px] md:h-[300px] lg:h-[525px] rounded-sm"
              alt="..."
            />

            <div className="carousel-caption absolute top-[44%] md:top-[49%] lg:top-[52.5%] left-[10%] md:left-[-17%] lg:left-[-20%] text-center opacity-90">
              <h5 className="text-[12px] md:text-[14.5px] lg:text-[24.5px] text-white font-extrabold uppercase ml-[-125px] md:ml-0">
                Recycle Hut
              </h5>
              <p className="text-white font-semibold text-[8.5px] md:text-[11px] lg:text-[15.5px] w-36 md:w-full">
                The best way for buying and selling your used phones
              </p>
            </div>
          </div>
          <div className="carousel-item relative float-left w-full">
            <img
              src={slider3}
              className="block w-full h-[220px] md:h-[300px] lg:h-[525px] rounded-sm"
              alt="..."
            />

            <div className="carousel-caption absolute text-end top-[32%] md:top-[36%] lg:top-[39.5%] opacity-90 md:mr-[-13px]">
              <h5 className="text-[12px] md:text-[16px] lg:text-[25.5px] text-slate-800 font-extrabold uppercase">
                Recycle Hut
              </h5>
              <p className="text-black font-semibold text-[9px] md:text-[11px] lg:text-[15.5px] w-[120px] md:w-full ml-auto">
                The best way for buying and selling used phones
              </p>
            </div>
          </div>
        </div>

        <button
          className="carousel-control-prev absolute top-0 bottom-0 flex items-center justify-center p-0 text-center border-0 hover:outline-none hover:no-underline focus:outline-none focus:no-underline left-0"
          type="button"
          data-bs-target="#carouselExampleCaptions"
          data-bs-slide="prev"
        >
          <span
            // className="carousel-control-prev-icon inline-block bg-no-repeat"
            aria-hidden="true"
          >
            <IoIosArrowDropleftCircle className="text-[25px] md:text-[30px] lg:text-[40px]" />
          </span>
          <span className="visually-hidden">Previous</span>
        </button>

        <button
          className="carousel-control-next absolute top-0 bottom-0 flex items-center justify-center p-0 text-center border-0 hover:outline-none hover:no-underline focus:outline-none focus:no-underline right-0"
          type="button"
          data-bs-target="#carouselExampleCaptions"
          data-bs-slide="next"
        >
          <span
            // className="carousel-control-next-icon inline-block bg-no-repeat"
            aria-hidden="true"
          >
            {/* <BiRightArrowCircle className="text-[35px]" /> */}
            <IoIosArrowDroprightCircle className="text-[25px] md:text-[30px] lg:text-[40px]" />
          </span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
    </div>
  );
};

export default Banner;
